export const sumMoney = (numA, numB) => {
  return parseFloat((parseFloat(numA) + parseFloat(numB)).toFixed(2))
}
